var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContextMenu',{attrs:{"menu":_vm.menus},on:{"select":_vm.handleClickItem}},[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }